import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSyncAlt = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	height: "24px",
	viewBox: "0 -960 960 960",
	width: "24px",
	fill: "#5f6368",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M280-120 80-320l200-200 57 56-104 104h607v80H233l104 104-57 56Zm400-320-57-56 104-104H120v-80h607L623-784l57-56 200 200-200 200Z" })
});
export default SvgSyncAlt;
